export default "__VITE_ASSET__dABt$4AD__"